import { Button } from "../ui/Button.jsx";
import { Badge } from "../ui/Badge.jsx";
import { HeroMock } from "./HeroMock.jsx";

export function Hero({ activeIndustry, onChangeIndustry }) {
  return (
    <section className="hero" id="top">
      <div className="container">
        <div className="hero-grid">
          <div className="hero-left">
            <Badge>In stealth · onboarding design partners</Badge>
            <h1 className="hero-h1">Find, understand and engage your customers.</h1>
            <p className="hero-sub">
              NgineRoom AI builds a deep understanding of your business — what you sell, what you
              have delivered, who your customers are and what they respond to — then builds and
              runs the software that grows it. One engine, shaped to your business, in any industry.
            </p>
            <div className="hero-ctas">
              <Button variant="primary" href="#waitlist">Join the waitlist</Button>
              <Button variant="ghost" href="#how">How it works</Button>
            </div>
            <div className="hero-trust">
              <span className="hero-trust-label">Marketing, data &amp; AI experience from</span>
              <span className="hero-trust-logos">Meta · Amazon · Netflix · Riot Games</span>
            </div>
          </div>
          <HeroMock activeIndex={activeIndustry} onChange={onChangeIndustry} />
        </div>
      </div>
    </section>
  );
}
